// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// import VeeValidate from 'vee-validate'

// Firebase
import firebase from './modules/firebase'
// Store
import store from './modules/store'
// Locale
// import locale from './modules/locale'

// Vue.use(VeeValidate)
Vue.use(Vuetify)
Vue.config.productionTip = false

/* eslint-disable no-new */
// var vm = new Vue({
new Vue({
  el: '#app',
  router,
  data: store,
  template: '<App/>',
  components: { App },
  beforeMount: function () {
    firebase.auth().onAuthStateChanged((user, error) => {
      if (user) {
        this.uid = user.uid
        firebase.database().ref('admin/').once('value')
        .then((snapshot) => {
          if (snapshot.hasChild(user.uid)) {
            this.admin = true
          }
        })
        // firebase.database().ref('users/').child(user.uid).once('value', (snapshot) => {
        firebase.database().ref('members/users/').child(user.uid).on('value', (snapshot) => {
          this.user = snapshot.val()
          // console.log('status: ' + this.user.status)
          // console.log('uid: ' + this.uid)
        })
      } else {
        console.log('not logged in')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js